<template>
  <div class="attribute">
    <div class="text-attr">
      <span class="attr-source">{{ propsData.source }}</span>
      <span class="attr-time">{{ time }}</span>
    </div>
    <v-voice v-if="hasAudio" ref="voice"></v-voice>
    <div class="btn-font-config" @click="showTranslatePopup">
      <i class="ico-translate icon-btn"></i>
      译
    </div>
    <div class="btn-font-config mr0" @click="showFontConfigPopup">
      <i class="ico-size-font icon-btn"></i>
      字
    </div>
    <fontSizeControler ref="fontSizeControler"></fontSizeControler>
    <TranlateControler ref="tranlateControler" @translate="translate"></TranlateControler>
  </div>
</template>

<script>
import { formatTime } from '@/views/detailPage/utils/time';
import { getQX } from '@/views/detailPage/utils/qsid';
import fontSizeControler from '@/views/detailPage/components/fontSizeControler';
import TranlateControler from '@/views/detailPage/components/TranlateControler';
import Voice from '../Voice';
export default {
  name: 'AttributeBar',
  props: {
    propsData: {
      default: () => ({
        author: ''
      })
    },
  },
  data() {
    return {
      isAudioing: false,
    };
  },
  components: {
    [fontSizeControler.name]: fontSizeControler,
    [TranlateControler.name]: TranlateControler,
    [Voice.name]: Voice,
  },
  computed: {
    time() {
      return this.propsData.time ? formatTime(this.propsData.time) : '';
    },
    hasAudio() {
      return getQX('audio') && ['1', '3'].includes(this.propsData.contentType);
    }
  },
  methods: {
    showFontConfigPopup() {
      this.$refs.fontSizeControler.showFontConfigPopup();
    },
    showTranslatePopup() {
      this.$refs.tranlateControler._showPopup();
    },
    translate(...args) {
      this.$emit('translate', ...args);
    }
  }
};
</script>

<style scoped lang='less'>
.attribute {
  padding: 0 @spacing-medium @spacing-small;
  color: @color-bg-gray;
  display: flex;
  justify-content: space-between;

  .attr-source {
    margin-right: 10px;
  }

  .text-attr {
    display: inline-block;
    flex: 1;
  }
}

.btn-font-config {
  margin-right: 6px;
  width: 36px;
  height: 24px;
  background: #ffffff;
  border-radius: 12px;
  border: 1px solid #EEEEEE;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #333333;
  font-size: 12px;
  box-sizing: border-box;
}
.mr0 {
  margin-right: 0;
}

.icon-btn {
  line-height: 30px;
  height: 30px;
}

.night {
  .text-attr {
    color: @color-bg-gray;
  }

  .btn-font-config {
    color: @dark-color-text-primary;
    border: 1px solid rgba(238, 238, 238, 0.12);
    background: @dark-color-bg-page;
  }
}
</style>
